import { IDocumentoCertificadora } from "../Componentes/InterfaceCertificadoras";

export const hasDocMandatory = (documentos: IDocumentoCertificadora[]) => {
    // console.log(documentos)
    let docMandatory = ["ESTATUTO", "CONTRATO SOCIAL"]  // MANDATÓRIO, OU SEJA, PERMITE O SALVAMENTO COM UM E APENAS UM DESTES DOCUMENTOS
    let qtde = 0;
    documentos.forEach(doc => {
        if (doc.nmDocumento && doc.statusReg === 1) {
            if (docMandatory.indexOf(doc.nmDocumento) > -1) {
                qtde += 1;
            }
        }
    })
    return qtde;

};